import { Interest } from 'utility/interfaces';

export const interests: Interest[] = [
    {
        text: 'The Stock Market',
        icon: 'line graph',
    },
    {
        text: 'Books',
        icon: 'book',
    },
    {
        text: 'Ping Pong',
        icon: 'table tennis',
    },
    {
        text: 'Programming',
        icon: 'code branch',
    },
    {
        text: 'Fancy Coffee',
        icon: 'coffee',
    },
    {
        text: 'New Food',
        icon: 'food',
    },
    {
        text: 'Browsing Reddit',
        icon: 'reddit',
    },
    {
        text: 'Anime & Bad TV',
        icon: 'tv',
    },
];
